export default __webpack_public_path__ + "static/media/PC-Needder.cb266ddc.png";